import { getObjectProp } from "@reco-m/core";

/**
 * 是否使用高德地图
 */
export const IS_USE_GD_MAP = getObjectProp(client, "isUseGDMap", false);
